// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1DPkv","list":"PatternAutocomplete_list__26829"};